import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { AccountPages } from "./AccountPages";
import { AreaPage } from "./AreaPage";
import { AreaDirectory } from "./AreaDirectory";
import "./styles.css";
import "./trip-result-assistant.css";
import "./quick-catch.css";
import "./catch-detail.css";
import "./camera-measure.css";
import "./ar-fish-measure.css";
import "./camera-auto-measure.css";
import "./personal-fishing-insights.css";
import "./AccountServicePlan.css";
import "./features/organization-workspace/organization-workspace.css";
import "./features/organization-application/organization-application.css";

const accountPath = ["/kirjaudu", "/rekisteroidy", "/oma", "/organisaatioille", "/organisaatio/"].some(path => window.location.pathname === path || window.location.pathname.startsWith(path));
const areaPath = window.location.pathname === "/alue" || window.location.pathname.startsWith("/alue/");
const areaDirectoryPath = window.location.pathname === "/alueet" || window.location.pathname === "/alueet/";
createRoot(document.getElementById("root")!).render(<StrictMode>{accountPath ? <AccountPages/> : areaDirectoryPath ? <AreaDirectory/> : areaPath ? <AreaPage/> : <App/>}</StrictMode>);
